import { MessageItem, Role } from '@/pages/ISWAN_CHAT/interface';
import { DecodedResponseChunk } from '@/pages/ISWAN_CHAT/utils/decodeResponseChunk';
import { formatThoughtMsg } from '@/pages/ISWAN_CHAT/utils/formatThoughtMsg';
import { randomStr } from '@/pages/ISWAN_CHAT/utils/randomStr';
import { FindMessagesFromRemoteResponse } from '@/services/AiService.interface';
import { MessageInfo } from '@ant-design/x/lib/use-x-chat';

export const parseMsgFormXChatMsg = (
  messages: MessageInfo<DecodedResponseChunk[]>[],
): MessageItem[] => {
  return messages.map((message) => {
    return {
      key: message.id,
      role: message.status === 'local' ? 'user' : 'assistant',
      content: message.message,
    };
  });
};

export const parseMsgFromDifyResponse = (
  messages: FindMessagesFromRemoteResponse['data'],
): MessageItem[] => {
  return messages
    .map((message) => {
      return [
        {
          key: randomStr(),
          role: 'user' as Role,
          content: [
            {
              type: 'message' as 'message',
              text: message.query,
              conversationId: message.conversation_id,
            },
          ],
        },
        {
          key: randomStr(),
          role: 'assistant' as Role,
          content: [
            {
              type: 'message' as 'message',
              text: formatThoughtMsg(message.answer),
              conversationId: message.conversation_id,
            },
          ],
        },
      ];
    })
    .flat();
};
